import { Action, createSelector, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RWorkGroup } from './r-work-group.action';
import { RightsScopeEnum } from '../../../../enums/rights/rights-scope.enum';

interface RWorkGroupXsStateModel {

  //organization
  viewOrganizationWorkGroup: string;
  createOrganizationWorkGroup: string;
  editOrganizationWorkGroup: string;
  deleteOrganizationWorkGroup: string;

  //community
  viewCommunityWorkGroup: string;
  createCommunityWorkGroup: string;
  editCommunityWorkGroup: string;
  deleteCommunityWorkGroup: string;

}

const getDefaults = () : RWorkGroupXsStateModel => ({
  viewOrganizationWorkGroup: null,
  createOrganizationWorkGroup: null,
  editOrganizationWorkGroup: null,
  deleteOrganizationWorkGroup: null,

  viewCommunityWorkGroup: null,
  createCommunityWorkGroup: null,
  editCommunityWorkGroup: null,
  deleteCommunityWorkGroup: null

});

@State<RWorkGroupXsStateModel>({
  name:       'rWorkGroup',
  defaults:   getDefaults()
})
@Injectable()
export class RWorkGroupXsState {

  //region SELECTOR
  @Selector()
  static canCreateAnyWorkGroup(state: RWorkGroupXsStateModel) : boolean {
    return state.createOrganizationWorkGroup != null || state.createCommunityWorkGroup != null;
  }

  static canViewWorkGroup(scope: RightsScopeEnum) {
    return createSelector([RWorkGroupXsState], (state: RWorkGroupXsStateModel) : boolean => {
      switch (scope) {
        case RightsScopeEnum.COMMUNITY:
          return state.viewCommunityWorkGroup != null;
        case RightsScopeEnum.ORGANIZATION:
          return state.viewOrganizationWorkGroup != null;
      }
      return false;
    });
  }

  static canCreateWorkGroup(scope: RightsScopeEnum) {
    return createSelector([RWorkGroupXsState], (state: RWorkGroupXsStateModel) : boolean => {
      switch (scope) {
        case RightsScopeEnum.COMMUNITY:
          return state.createCommunityWorkGroup != null;
        case RightsScopeEnum.ORGANIZATION:
          return state.createOrganizationWorkGroup != null;
      }
      return false;
    });
  }

  static canEditWorkGroup(scope: RightsScopeEnum) {
    return createSelector([RWorkGroupXsState], (state: RWorkGroupXsStateModel) : boolean => {
      switch (scope) {
        case RightsScopeEnum.COMMUNITY:
          return state.editCommunityWorkGroup != null;
        case RightsScopeEnum.ORGANIZATION:
          return state.editOrganizationWorkGroup != null;
      }
      return false;
    });
  }

  @Selector()
  static canEditAnyWorkGroup(state: RWorkGroupXsStateModel) : boolean {
    return state.editOrganizationWorkGroup != null || state.editCommunityWorkGroup != null;
  }

  static canDeleteWorkGroup(scope: RightsScopeEnum) {
    return createSelector([RWorkGroupXsState], (state: RWorkGroupXsStateModel) : boolean => {
      switch (scope) {
        case RightsScopeEnum.COMMUNITY:
          return state.deleteCommunityWorkGroup != null;
        case RightsScopeEnum.ORGANIZATION:
          return state.deleteOrganizationWorkGroup != null;
      }
      return false;
    });
  }
  //endregion

  //region ACTIONS
  @Action(RWorkGroup.SetWorkGroupPrivileges)
  public setWorkGroupPrivileges(ctx: StateContext<RWorkGroupXsStateModel>, action: RWorkGroup.SetWorkGroupPrivileges) {
    const state = ctx.getState();
    const workGroupPrivileges = [...action.activeUserRightInfoDtoModel.workGroupPrivileges];

    //find user privilege data model
    const viewOrganizationWorkGroup = workGroupPrivileges.find(id => id === UserPrivilegeEnum.VIEW_ORGANIZATION_WORK_GROUP);
    const createOrganizationWorkGroup = workGroupPrivileges.find(id => id === UserPrivilegeEnum.CREATE_ORGANIZATION_WORK_GROUP);
    const editOrganizationWorkGroup = workGroupPrivileges.find(id => id === UserPrivilegeEnum.EDIT_ORGANIZATION_WORK_GROUP);
    const deleteOrganizationWorkGroup = workGroupPrivileges.find(id => id === UserPrivilegeEnum.DELETE_ORGANIZATION_WORK_GROUP);

    const viewCommunityWorkGroup = workGroupPrivileges.find(id => id === UserPrivilegeEnum.VIEW_COMMUNITY_WORK_GROUP);
    const createCommunityWorkGroup = workGroupPrivileges.find(id => id === UserPrivilegeEnum.CREATE_COMMUNITY_WORK_GROUP);
    const editCommunityWorkGroup = workGroupPrivileges.find(id => id === UserPrivilegeEnum.EDIT_COMMUNITY_WORK_GROUP);
    const deleteCommunityWorkGroup = workGroupPrivileges.find(id => id === UserPrivilegeEnum.DELETE_COMMUNITY_WORK_GROUP);


    //set the state
    ctx.setState({
      ...state,
      viewOrganizationWorkGroup: viewOrganizationWorkGroup,
      createOrganizationWorkGroup: createOrganizationWorkGroup,
      editOrganizationWorkGroup: editOrganizationWorkGroup,
      deleteOrganizationWorkGroup: deleteOrganizationWorkGroup,

      viewCommunityWorkGroup: viewCommunityWorkGroup,
      createCommunityWorkGroup: createCommunityWorkGroup,
      editCommunityWorkGroup: editCommunityWorkGroup,
      deleteCommunityWorkGroup: deleteCommunityWorkGroup
    });

  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RWorkGroupXsStateModel>): void {
    ctx.setState({...getDefaults()});
  }
  //endregion

}
